import { useCallback, useEffect, useState } from "react";
import { connect } from "react-redux";
import { Table, Row, Col } from "reactstrap";
import { getDocuments } from "../actions";
import Paginator from "../../../components/Paginator";
import DocumentsTableRow from "./DocumentsTableRow";
import { DOCUMENTS_TABLE_HEADERS } from "../constants";
import CampaignTableSkeleton from "../../campaigns/CampaignsTableSkeleton";

const DocumentsTable = ({
  documents,
  totalDocumentsCount,
  getDocuments,
  loading,
  ...props
}) => {
  const [activePage, setActivePage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const fetchDocuments = useCallback(() => {
    getDocuments({
      pageNumber: activePage,
      pageSize,
    });
  }, [activePage, getDocuments, pageSize]);

  useEffect(() => {
    fetchDocuments();
  }, [fetchDocuments]);

  const columnHeaders = DOCUMENTS_TABLE_HEADERS.map((header, index) => (
    <th scope="col" key={index} className={header.class} width={header.width}>
      {header.heading}
    </th>
  ));

  const tableData = documents.map((document) => (
    <DocumentsTableRow key={document._id} document={document} />
  ));

  if (loading) return <CampaignTableSkeleton />;

  return (
    <Row className="search-results-wrap">
      <Col md="12">
        <div className="table-responsive table-outer">
          <Table hover borderless>
            <caption className="sr-only">Your Documents</caption>
            <thead>
              <tr>{columnHeaders}</tr>
            </thead>
            <tbody>
              {documents && documents.length ? (
                tableData
              ) : (
                <tr>
                  <td colSpan={DOCUMENTS_TABLE_HEADERS.length} align="center">
                    <h3 className="title bold mb-1 mt-5">
                      No documents found.
                    </h3>
                    <p className="text-grey mb-5">
                      Documents will be displayed here once they are uploaded.
                    </p>
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
          {totalDocumentsCount > 10 && (
            <Paginator
              activePage={activePage}
              pageSize={pageSize}
              totalItems={totalDocumentsCount}
              handlePageChange={(pageNumber) => {
                setActivePage(pageNumber);
              }}
              handlePageSizeChange={(size) => {
                setPageSize(size);
              }}
            />
          )}
        </div>
      </Col>
    </Row>
  );
};

const mapStateToProps = (state) => {
  return {
    documents: state.documents.documents,
    totalDocumentsCount: state.documents.totalDocumentsCount,
    loading: state.documents.loading,
  };
};

export default connect(mapStateToProps, {
  getDocuments,
})(DocumentsTable);
